import { IOneMessageJson } from "../../../../nodeserver/structs/database.js";
import { MessageDeletedEvent, MessageEditedEvent, MessageReadEvent, NewMessageEvent } from "../../../../nodeserver/structs/websocket.js";
import { createOneMessageJson, rebuildMessage } from "./helpers.js";
import { Messages } from "./messages.js";
import { OneDialog } from "./one-dialog.js";
import { Websocket } from "../websocket.js";

let receivedMessageFromId = new Map<number, number>();

Websocket.Instance

    .on<NewMessageEvent>("new-message", (event: NewMessageEvent) => {
        const message: IOneMessageJson = (event as NewMessageEvent).message,
            dialog_id = message.to_id <= 0 ? message.to_id : (message.from_id == user_id ? message.to_id : message.from_id),
            globalCounter = $('.messages-btn');
        let dialog: OneDialog | undefined = Messages.Instance?.dialogs?.find(e => e.data.user_id === dialog_id);
        if (dialog) {
            dialog.lastMessageText = message.text;
            if (message.from_id != user_id && message.to_id > 0) {
                dialog.unreadCount++;
            }
            if (dialog.messages.length || dialog.fullLoaded)
                dialog.addMessage(message, true);
            if (dialog.selected && dialog.messagesShown && message.to_id == user_id && dialog.canReadMessages) {
                if (document.visibilityState === 'visible')
                    Websocket.Instance.readMessages(dialog_id);
            }
        } else {
            OneDialog.create({
                user_id: dialog_id,
                unread_count: 1,
                last_message: message.text,
                avatars: message.avatars,
                roles: [],
                nickname: message.nickname,
                banned: false,
                date: Math.floor(+new Date/1000),
                last_online: Math.floor(+new Date/1000),
                last_message_deleted: message.deleted
            }, 'prepend');
        }

        // if ToId=user_id then it's a private dialog else — a chat
        if (message.to_id === user_id) {
            if (receivedMessageFromId.has(message.from_id)) {
                receivedMessageFromId.set(message.from_id, receivedMessageFromId.get(message.from_id)! + 1);
            } else {
                receivedMessageFromId.set(message.from_id, 1);
                globalCounter.attr('data-not-viewed', (+globalCounter.attr('data-not-viewed')!) + 1);
            }
        }

    })
    .on<MessageReadEvent>("message-read", async (event) => {
        await new Promise(r => setTimeout(r, 500));
        const dialog = Messages.Instance?.dialogs?.find(e => e.data.user_id == event.user_id),
            globalCounter = $('.messages-btn');
        if (!dialog) return;
        dialog.unreadCount = 0;
        if (!event.is_owner) {
            globalCounter.attr('data-not-viewed', (+globalCounter.data('not-viewed')!) - 1);
            receivedMessageFromId.delete(event.user_id)
        }
        for (let msg of dialog.messages) {
            msg.element.removeClass('unread');
        }
    })
    .on<MessageEditedEvent>("message-edited", async (event) => {
        const msg = event.message;
        rebuildMessage(msg);
        let messages = $(`.one-message[data-answer-to-id="${msg.id}"]`).toArray();

        messages.forEach(element => {
            const json = createOneMessageJson($(element));
            json.message_to_answer = msg.text;
            rebuildMessage(json);
        });
    })

    .on<MessageDeletedEvent>("message-deleted", async (event) => {
        rebuildMessage(event.message);

    });